export enum Electronics {
    ProductGroup = 'electronics.product_group',
    BasicProduct = 'electronics.basic_product',
}
